import endpoints from "./endpoints";

export const KEY_TOKEN = 'edi-token';

export const getRefreshToken = () => {
  try {
    const token = JSON.parse(localStorage.getItem(KEY_TOKEN) as string);
    return token.refresh;
  } catch (e) {
    return null;
  }
};

export const getAccessToken = () => {
  try {
    const token = JSON.parse(localStorage.getItem(KEY_TOKEN) as string);
    return token.access;
  } catch (e) {
    return null;
  }
};

export function authHeader(withToken=true) {
  // return authorization header with jwt token
  const token = getAccessToken();
  const defaultHeaders = {
    'Accept': 'application/json',
    "Content-Type": "application/json; charset=utf-8",
  };

  if (withToken && token) {
    return Object.assign(
      defaultHeaders,
      { 'Authorization': `Bearer ${token}` },  // JWT Token
    );
  } else {
    return defaultHeaders;
  }
}

export const nonAuthRouters = [
  endpoints.api.auth.token,
  endpoints.api.auth.refresh,
];
